import React, { useContext, useState } from "react";
import { EditorContext, ModalServiceContext, RicosContext } from "./../../ricos-context";
import { RICOS_LINE_SPACING_TYPE } from "./../../wix-rich-content-common";
import { lineSpacingModals } from "./../consts";
import { FloatingLayout } from "./../../ui-components";
import { CustomSpacingEditorModal } from "../custom-spacing-editor-modal/custom-spacing-editor-modal";
import { MODAL_ROOT } from "../data-hooks";
import { useCurrentSpacing } from "./get-current-selection";
import classes from "./insert-decoration-modal-scss";
import { SpacingSelector } from "./spacing-selector/spacing-selector";
import { SpacingSelectorFooter } from "./spacing-selector/spacing-selector-footer";
const InsertDecorationModal = ({
  closeModal,
  referenceElement
}) => {
  const { getEditorCommands } = useContext(EditorContext);
  const { t, isMobile } = useContext(RicosContext);
  const editorCommands = getEditorCommands();
  const modalService = useContext(ModalServiceContext);
  const lineSpacing = useCurrentSpacing();
  const [initialLineSpacing] = useState(lineSpacing);
  const insertDecoration = (data, options = {}) => {
    editorCommands.insertDecoration(
      RICOS_LINE_SPACING_TYPE,
      {
        data
      },
      options
    );
    closeModal();
  };
  const openCustomSpacingEditor = () => {
    modalService.openModal({
      id: lineSpacingModals.customSpacing,
      Component: CustomSpacingEditorModal,
      componentProps: {
        initialLineSpacing,
        insertDecoration
      },
      layout: isMobile ? "fullscreen" : "floating",
      withTransition: true,
      positioning: {
        referenceElement,
        placement: "bottom"
      },
      enableDrag: !isMobile,
      dragHandleSelector: "[data-drag-handler]",
      onClickOutside: () => {
      },
      disableArrowNavigation: true
    });
  };
  return /* @__PURE__ */ React.createElement(
    FloatingLayout,
    {
      dataHook: MODAL_ROOT,
      sidePanelProps: { width: isMobile ? "100%" : "fit-content", className: classes.panelRoot },
      onCloseButtonClick: () => {
        insertDecoration(initialLineSpacing, { shouldFocus: true });
      },
      header: isMobile ? {
        prefix: null,
        title: t("LineSpacing_lineSpacing_Header"),
        showDivider: true
      } : void 0,
      content: {
        noPadding: true,
        children: /* @__PURE__ */ React.createElement(
          SpacingSelector,
          {
            lineSpacing,
            initialLineSpacing,
            onSelectSpacing: insertDecoration
          }
        )
      },
      footer: {
        className: classes.footer,
        children: /* @__PURE__ */ React.createElement(SpacingSelectorFooter, { onOpenCustomEditor: openCustomSpacingEditor })
      }
    }
  );
};
export {
  InsertDecorationModal
};
//# sourceMappingURL=insert-decoration-modal.js.map
